export enum WizardStep {
  WELCOME = 'welcome',
  BOAS_VINDAS = 'boas-vindas',
  CAMINHO_ENTRADA = 'caminho-entrada',
  IFOOD_PERGUNTA = 'ifood-pergunta',
  CAMINHOS = 'caminhos',
  IMPORTACAO = 'importacao',
  LOGO = 'logo',
  SUBDOMINIO = 'subdominio',
  MODO_VENDA = 'modo-venda',
  PRODUTOS = 'passo-produtos',
  TEMA = 'tema',
  CONCLUSAO = 'conclusao'
}

export type CaminhoEntrada = 'importar' | 'template' | 'zero' | 'planilha';
export type ModoDeVenda = 'catalogo' | 'delivery' | 'retirada' | 'mesa';
export type PlataformaImportacao = 'ifood' | 'anotaai' | 'cardapioweb' | 'cardapioai' | 'olaclick' | 'goomer' | 'uairango' | 'aiqfome' | 'instadelivery' | 'menudino' | 'deliverydireto' | 'takeat' | 'yooga' | 'whatsmenu' | 'brendi' | 'meucardapio';

export interface ProdutoWizard {
  id?: number | null;
  nome: string;
  descricao: string;
  preco: number;
  imagem?: string;
  categoria: string;
  exemplo?: boolean;
  selecionado: boolean;
  salvo?: boolean;
  adicionais?: any[];
  payload?: any;
}

export interface CategoriaWizard {
  nome: string;
  produtos: ProdutoWizard[];
}

export interface WizardState {
  passoAtualIndex: number;
  passosAtivos: WizardStep[];
  caminhoEscolhido: CaminhoEntrada | null;
  segmento: string | null;
  nomeEmpresa: string;
  subdominio: string;
  subdominioDisponivel: boolean | null;
  modosDeVenda: ModoDeVenda[];
  plataformaImportacao: PlataformaImportacao | null;
  urlImportacao: string;
  categoriasImportadas: CategoriaWizard[];
  produtosImportados: ProdutoWizard[];
  produtosTemplate: ProdutoWizard[];
  produtosManuais: ProdutoWizard[];
  logoUrl: string | null;
  capaUrl: string | null;
  temaSelecionado: string | null;
  telefone: string | null;
  enderecoImportado: string | null;
  cep: string | null;
  latitudeLongitude: string | null;
  completou: boolean;
}

export const WIZARD_STATE_INICIAL: WizardState = {
  passoAtualIndex: 0,
  passosAtivos: [],
  caminhoEscolhido: null,
  segmento: null,
  nomeEmpresa: '',
  subdominio: '',
  subdominioDisponivel: null,
  modosDeVenda: [],
  plataformaImportacao: null,
  urlImportacao: '',
  categoriasImportadas: [],
  produtosImportados: [],
  produtosTemplate: [],
  produtosManuais: [],
  logoUrl: null,
  capaUrl: null,
  temaSelecionado: null,
  telefone: null,
  enderecoImportado: null,
  cep: null,
  latitudeLongitude: null,
  completou: false
};

export const WIZARD_STEP_LABELS: Record<WizardStep, string> = {
  [WizardStep.WELCOME]: 'Início',
  [WizardStep.BOAS_VINDAS]: 'Loja',
  [WizardStep.CAMINHO_ENTRADA]: 'Caminho',
  [WizardStep.IFOOD_PERGUNTA]: 'iFood',
  [WizardStep.CAMINHOS]: 'Como começar',
  [WizardStep.IMPORTACAO]: 'Importar',
  [WizardStep.LOGO]: 'Logo',
  [WizardStep.SUBDOMINIO]: 'Endereço',
  [WizardStep.MODO_VENDA]: 'Venda',
  [WizardStep.PRODUTOS]: 'Produtos',
  [WizardStep.TEMA]: 'Tema',
  [WizardStep.CONCLUSAO]: 'Pronto!'
};

export const WIZARD_STEP_ICONS: Record<WizardStep, string> = {
  [WizardStep.WELCOME]: 'fe-star',
  [WizardStep.BOAS_VINDAS]: 'fe-home',
  [WizardStep.CAMINHO_ENTRADA]: 'fe-compass',
  [WizardStep.IFOOD_PERGUNTA]: 'fe-smartphone',
  [WizardStep.CAMINHOS]: 'fe-map',
  [WizardStep.IMPORTACAO]: 'fe-download',
  [WizardStep.LOGO]: 'fe-image',
  [WizardStep.SUBDOMINIO]: 'fe-globe',
  [WizardStep.MODO_VENDA]: 'fe-shopping-cart',
  [WizardStep.PRODUTOS]: 'fe-box',
  [WizardStep.TEMA]: 'fe-droplet',
  [WizardStep.CONCLUSAO]: 'fe-check-circle'
};
